import { setMyTemplate, queryTemplateList, queryTemplateType, queryPageListByTemplateId } from "./template"
import {
  queryWebJson,
  queryPageInfo,
  queryAllPages,
  deletePage,
  updatePageName,
  saveWebJson,
  saveWebJsonPcApp,
  previewPage,
  clonePage,
  addSubPage,
  previewPageWithCache,
  querySubPageList,
  queryPageAttr,
  updatePageAttr,
  queryPageList,
  updateWebsiteCover,
  queryPageName,
  queryEditPageList,
  addSubPageLink,
  updateSubPageLink,
  queryEditWebJson,
  clonePages,
  replacePage,
  generateSubHeadPage
} from "./page"
import {
  queryComponentList,
  queryComponentTypeTree,
  queryDefaultComponent,
  createComponentApp,
  repairDirtyDataApp,
  createSystemComponentApp,
  createSystemComponentAppClone,
  queryComponentContent,
  queryComponentContentClone,
  queryFirstComponentContent,
  collectListsType,
  collectListsAll,
  collectListsTypeMore,
  collectCoverNameChange
} from "./module"

import {
  queryAppCategoryAndApp,
  queryClassifyData,
  queryCrumbData,
  queryDetailData,
  queryClassifyDetail,
  queryChartData,
  querySearchEngineList,
  querySearchEngineClassify,
  querySearchEngineData,
  queryExchangeDetail,
  queryAppManage,
  updateAppAttr,
  updateAppPageAttr,
  queryGroupSearchEngineList,
  queryGroupSearchEngineData,
  updateAppPageAttrBatch,
  editDataPushRule,
  getDataPushRule,
  getDataCenterUrl,
  getContentConfig,
  getEngineInstance,
  setLocalData,
  querySearchFastLink,
  getMustInIframe
} from "./engine2"

import {
  queryWeather,
  querySvg,
  getDetailPagePermission,
  getPermissionList,
  getEditPagePermission,
  getCookie,
  getUserInfo,
  getPreference,
  updatePreference,
  getIP, getComponentPermission
} from "./authority"

export default {
  setMyTemplate,
  queryTemplateList,
  queryPageInfo,
  queryAllPages,
  deletePage,
  updatePageName,
  saveWebJson,
  saveWebJsonPcApp,
  generateSubHeadPage,
  previewPage,
  clonePage,
  addSubPage,
  previewPageWithCache,
  querySubPageList,
  queryPageAttr,
  updatePageAttr,
  queryPageList,
  updateWebsiteCover,
  queryPageName,
  queryWebJson,
  queryComponentTypeTree,
  queryEditPageList,
  addSubPageLink,
  updateSubPageLink,
  queryEditWebJson,
  queryComponentList,
  queryTemplateType,
  queryPageListByTemplateId,
  clonePages,
  replacePage,
  queryDefaultComponent,
  createComponentApp,
  repairDirtyDataApp,
  queryAppCategoryAndApp,
  queryClassifyData,
  queryCrumbData,
  queryDetailData,
  queryClassifyDetail,
  queryChartData,
  querySearchEngineList,
  querySearchFastLink,
  querySearchEngineClassify,
  querySearchEngineData,
  queryExchangeDetail,
  queryAppManage,
  updateAppAttr,
  updateAppPageAttr,
  editDataPushRule,
  getDataPushRule,
  getDataCenterUrl,
  getContentConfig,
  getEngineInstance,
  setLocalData,
  createSystemComponentApp,
  createSystemComponentAppClone,
  queryComponentContent,
  queryComponentContentClone,
  queryWeather,
  querySvg,
  getDetailPagePermission,
  getComponentPermission,
  getPermissionList,
  getEditPagePermission,
  getCookie,
  getUserInfo,
  getIP,
  queryFirstComponentContent,
  queryGroupSearchEngineList,
  queryGroupSearchEngineData,
  updateAppPageAttrBatch,
  getPreference,
  updatePreference,
  collectListsType,
  collectListsAll,
  collectListsTypeMore,
  collectCoverNameChange,
  getMustInIframe
}
